export default __webpack_public_path__ + "static/media/ios-hint.f187de81.png";